module.exports = __webpack_public_path__ + "static/media/scheduling_system.23d46565.svg";